module.exports = __webpack_public_path__ + "img/agree-active.d872fb6c.gif";